import { DefaultState } from 'store/types';
import { GetUserRow } from 'store/reducers/user/get-users/types';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';
export const GET_USER_CLEAR = 'GET_USER_CLEAR';

export type GetUserState = DefaultState & {
  contents?: GetUserRow;
};

interface GetUserRequest {
  type: typeof GET_USER_REQUEST;
}

interface GetUserSuccess {
  type: typeof GET_USER_SUCCESS;
  contents: GetUserRow;
}

interface GetUserFailure {
  type: typeof GET_USER_FAILURE;
}

interface GetUserClear {
  type: typeof GET_USER_CLEAR;
}

export type GetUserActionTypes = GetUserRequest | GetUserSuccess | GetUserFailure | GetUserClear;